module.exports = __webpack_public_path__ + "static/media/email@.c9af7fc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email@.svg
// module id = 855
// module chunks = 0